import { render, staticRenderFns } from "./data84.vue?vue&type=template&id=51ecbf26&scoped=true&"
import script from "./data84.vue?vue&type=script&lang=js&"
export * from "./data84.vue?vue&type=script&lang=js&"
import style1 from "./data84.vue?vue&type=style&index=1&id=51ecbf26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecbf26",
  null
  
)

export default component.exports